export interface PageSeo {
  title: string;
  description: string;
  path: string;
  image?: string;
  noindex?: boolean;
  schema?: Record<string, unknown>;
}

export const HOME_TITLE = 'Showladex — Discover TV Shows & Track What to Watch';
export const HOME_DESCRIPTION = 'Discover trending TV shows and movies, explore cast and trailers, save your favorite shows, and track upcoming episodes with Showladex.';

export function updateSeo(page: PageSeo) {
  document.title = page.title;
  const canonical = `https://www.showladex.com${page.path}`;
  const tags = {
    description: page.description,
    robots: page.noindex ? 'noindex,follow' : 'index,follow',
    'og:title': page.title,
    'og:description': page.description,
    'og:url': canonical,
    'og:type': 'website',
    'og:site_name': 'Showladex',
    'og:image': page.image || 'https://www.showladex.com/logo512.png',
    'twitter:card': page.image ? 'summary_large_image' : 'summary',
  };
  Object.entries(tags).forEach(([name, content]) => {
    const attribute = name.startsWith('og:') ? 'property' : 'name';
    let tag = document.querySelector<HTMLMetaElement>(`meta[${attribute}="${name}"]`);
    if (!tag) {
      tag = document.createElement('meta');
      tag.setAttribute(attribute, name);
      document.head.appendChild(tag);
    }
    tag.content = content;
  });
  let link = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!link) {
    link = document.createElement('link');
    link.rel = 'canonical';
    document.head.appendChild(link);
  }
  link.href = canonical;
  let schemaTag = document.querySelector<HTMLScriptElement>('#page-schema');
  const schema = page.schema || (page.path === '/' ? {
    '@context': 'https://schema.org', '@type': 'WebSite', name: 'Showladex', url: canonical,
  } : undefined);
  if (schema) {
    if (!schemaTag) {
      schemaTag = document.createElement('script');
      schemaTag.id = 'page-schema';
      schemaTag.type = 'application/ld+json';
      document.head.appendChild(schemaTag);
    }
    schemaTag.textContent = JSON.stringify(schema);
  } else {
    schemaTag?.remove();
  }
}
